<template>
  <div>
    <q-form @submit.prevent="salvar">
      <div class="row">
        <div class="col-sm-5 col-xs-12 q-pr-sm">
          <q-input
            dense
            label="Nome"
            v-model="pesquisa.nome"
            :rules="[val => !!val || 'O nome é obrigatório']"
            :disable="isEditing"
          />
        </div>
        <div class="col-sm-3 col-xs-12">
          <q-input
            dense
            label="Validade"
            v-model="pesquisa.validade"
            mask="##/##/####"
            fill-mask
            :rules="[val => !!val.replace(/\D/g, '') || 'A validade é obrigatória']"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <q-stepper
            v-model="step"
            ref="stepper"
            color="primary"
            animated
          >
            <q-step
              :name="1"
              title="Definir perguntas"
              icon="question_answer"
              :done="step > 1"
            >
              <q-banner class="bg-orange text-white" v-if="isEditing">
                Você não pode fazer alterações nas perguntas. Apenas nos usuários.
              </q-banner>
              <q-table
                dense
                title="Perguntas"
                :data="pesquisa.perguntas"
                :columns="columnsPerguntas"
                :grid="false"
              >
                <template v-slot:top-right>
                  <q-btn
                    label="Nova pergunta"
                    icon="add"
                    flat
                    color="primary"
                    @click="dialogNovaPergunta = true"
                    :disable="isEditing"
                  />
                </template>
                <template v-slot:body-cell-remover="props">
                  <q-td class="text-right">
                    <q-btn
                      icon="delete"
                      round
                      dense
                      flat
                      color="red"
                      @click="removePergunta(props.row.pergunta)"
                      :disable="isEditing"
                    />
                  </q-td>
                </template>
              </q-table>
            </q-step>
            <q-step
              :name="2"
              title="Selecionar usuários"
              icon="people"
            >
              <q-table
                class="my-sticky-header-table"
                style="height: 300px"
                dense
                title="Perguntas"
                :data="usuarios"
                :selected.sync="pesquisa.usuarios"
                selection="multiple"
                row-key="cpf"
                :columns="columnsUsuarios"
                virtual-scroll
                :rows-per-page-options="[0]"
              >
              </q-table>
            </q-step>

            <template v-slot:navigation>
              <q-stepper-navigation>
                <q-btn
                  v-if="step === 1"
                  @click="$refs.stepper.next()"
                  color="primary"
                  label="Continuar"
                  :disable="!pesquisa.perguntas.length"
                />
                <q-btn
                  v-if="step === 2"
                  color="primary"
                  type="submit"
                  label="Finalizar"
                  :disable="!pesquisa.usuarios.length"
                />
                <q-btn v-if="step > 1" flat color="primary" @click="$refs.stepper.previous()" label="Voltar" class="q-ml-sm" />
              </q-stepper-navigation>
            </template>
          </q-stepper>
        </div>
      </div>
    </q-form>

    <q-dialog 
      v-if="dialogNovaPergunta"
      :value="true"
      persistent
      full-width
      :maximized="$q.screen.lt.md"
    >
      <q-card >
        <q-card-section class="row items-center q-pa-sm bg-primary text-white">
          <div class="text-h6">Adicionar pergunta</div>
          <q-space />
          <q-btn icon="close" flat round dense @click="dialogNovaPergunta = false" />
        </q-card-section>
        <q-card-section class="q-pa-none">
          <FormNovaPergunta @on-add="onAddPergunta" />
        </q-card-section>
      </q-card>
    </q-dialog>

  </div>
</template>

<script>
import FormNovaPergunta from './FormNovaPergunta'
import { getUsers } from '../../services/usuario'
import { criarPesquisa, atualizarPesquisa } from '../../services/pesquisa'
import moment from 'moment'

export default {
  props: {
    pesquisaSelecionada: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      step: 1,
      dialogNovaPergunta: false,
      usuarios: [],
      columnsPerguntas: [
        { name: 'pergunta', field: 'pergunta', label: 'Pergunta', align: 'left' },
        { name: 'tipo', field: 'tipo', label: 'Tipo', align: 'left', format: value => this.getTipoPergunta(value) },
        { name: 'required', field: 'required', label: 'Obrigatória', align: 'left', format: value => value ? 'SIM': 'NÃO' },
        { name: 'opcoes', field: 'opcoes', label: 'Opções', align: 'left', format: (value = []) => value.join(', ') },
        { name: 'remover', field: 'remover', label: 'Remover'},
      ],
      columnsUsuarios: [
        { name: 'nome', field: 'nome', label: 'Nome', align: 'left' },
        { name: 'cpf', field: 'cpf', label: 'CPF', align: 'left' },
        { name: 'email', field: 'email', label: 'Email', align: 'left' },
      ],
      pesquisa: {
        nome: '',
        validade: '',
        usuarios: [],
        perguntas: []
      }
    }
  },

  mounted () {
    this.getUsuarios()
    if (this.pesquisaSelecionada._id) {
      this.pesquisa = {
        ...this.pesquisaSelecionada,
        validade: moment(this.pesquisaSelecionada.validade).format('DDMMYYYY'),
      }
    }
  },

  methods: {
    getTipoPergunta (value) {
      const tipos = {
        check: 'Múltipla escolha',
        radio: 'Única',
        text: 'Texto'
      }
      const tipo = tipos[value]
      return tipo
    },

    onAddPergunta (pergunta) {
      this.pesquisa.perguntas = [
        ...this.pesquisa.perguntas,
        pergunta
      ]
      this.dialogNovaPergunta = false
    },

    removePergunta (pergunta = '') {
      this.$q.dialog({
        title: 'Confirmação',
        message: 'Deseja realmente remover a pergunta?',
        cancel: true,
        persistent: true
      }).onOk(() => {
        this.pesquisa.perguntas = this.pesquisa.perguntas
          .filter(x => x.pergunta.toLowerCase() !== pergunta.toLowerCase())
      })
    },

    async getUsuarios () {
      try {
        const response = await getUsers()
        this.usuarios = response.users
      } catch (error) {
        console.error(error)
      }
    },

    salvar () {
      if (this.isEditing) {
        return this.atualizarPesquisa()
      }

      this.criarPesquisa()
    },

    async criarPesquisa () {
      try {
        const usuarios = this.pesquisa.usuarios.map(usuario => {
          const { nome, cpf, email } = usuario
          return {
            nome,
            cpf,
            email
          }
        })
        const validade = new Date(moment(this.pesquisa.validade, 'DD/MM/YYYY').format()).toISOString()
        const pesquisa = {
          ...this.pesquisa,
          validade,
          usuarios
        }
        await criarPesquisa(pesquisa)
        this.$q.notify({
          color: 'green',
          position: 'top-right',
          icon: 'check',
          message: 'Pesquisa criada com sucesso!'
        })
        this.$emit('on-save')
      } catch (error) {
        console.error(error)
        this.$q.notify({
          color: 'red',
          position: 'top-right',
          icon: 'report_problem',
          message: 'Não foi possível salvar a pesquisa. Tente daqui a pouco!'
        })
      }
    },

    async atualizarPesquisa () {
      try {
        const usuarios = this.pesquisa.usuarios.map(usuario => {
          const { nome, cpf, email } = usuario
          return {
            nome,
            cpf,
            email
          }
        })
        const validade = new Date(moment(this.pesquisa.validade, 'DD/MM/YYYY').format()).toISOString()
        const pesquisa = {
          ...this.pesquisa,
          validade,
          usuarios
        }
        await atualizarPesquisa(pesquisa)
        this.$q.notify({
          color: 'green',
          position: 'top-right',
          icon: 'check',
          message: 'Pesquisa atualizada com sucesso!'
        })
        this.$emit('on-save')
      } catch (error) {
        console.error(error)
        this.$q.notify({
          color: 'red',
          position: 'top-right',
          icon: 'report_problem',
          message: 'Não foi possível salvar a pesquisa. Tente daqui a pouco!'
        })
      }
    }
  },

  components: {
    FormNovaPergunta
  },

  computed: {
    isEditing () {
      return !!this.pesquisa._id
    }
  }
}
</script>

<style scoped>
  .card-desktop {
    width: 700px; max-width: 80vw;
  }
</style>

<style lang="sass">
.my-sticky-header-table
  /* height or max-height is important */
  height: 310px

  .q-table__top,
  .q-table__bottom,
  thead tr:first-child th
    /* bg color is important for th; just specify one */
    background-color: #FFF

  thead tr th
    position: sticky
    z-index: 1
  thead tr:first-child th
    top: 0

  /* this is when the loading indicator appears */
  &.q-table--loading thead tr:last-child th
    /* height of all previous header rows */
    top: 48px
</style>